import Relay from 'react-relay';
/**
*  Unlock locker mutation
*/
export default class UnlockLockerMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      openLocker
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
        lockerId: this.props.lockerId,
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on openLockerPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
      }
    `;
  }

  /**
  *  Config
  */
 getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/UnlockLockerMutation.js